import React, {useState, useEffect} from 'react';

const Button = ({ children, type = "full", onClick = () => {}, disabled = false, classes = "" }) => {
    const types = {
        full: "flex justify-center items-center bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg hover:cursor-pointer active:scale-95 transition-all",
        hollow: "flex justify-center items-center border-2 border-blue-600 text-blue-600 hover:bg-gray-200 hover:dark:bg-neutral-800 font-medium py-2 px-4 rounded-lg hover:cursor-pointer active:scale-95 transition-all",
        icon: "text-blue-600 hover:cursor-pointer active:scale-95 transition-all"
    };

    const [buttonClasses, setButtonClasses] = useState(types[type]);

    useEffect(() => {
        setButtonClasses(types[type]);
    }, [type]);

    return (
        <button className={`text-xs md:text-base ${buttonClasses} ${classes} ${disabled && 'opacity-50 cursor-not-allowed'}`} onClick={onClick} disabled={disabled}>
            {children}
        </button>
    );
};

export default Button;